import AxiosConfig from '../../../config/AxiosConfig';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../states/app/staticSlice';

function useDashboardOrderRefs() {
  const dispatch = useDispatch();
  const getReferences = async (formData) => {
    const response = await AxiosConfig.create(
      'put',
      '/dashboard-order/references'
    )
      .call(formData)
      .getResponseData();
    if (response?.code > 300) {
      const messageError = `Error ${response?.code} - ${response?.errorMessage} in useDashboardOrderRefs`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    }
    return {
      references: response?.data?.references,
    };
  };
  return {
    getReferences: getReferences,
  };
}

export default useDashboardOrderRefs;
